import React from 'react';
import { Stack, NumberInput, Text, Tooltip, Group, Switch } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

function AdvancedSettingsFields({ formData, onChange, errors }) {
  return (
    <Stack>
      <NumberInput
        label={
          <Group gap="xs">
            <span>Booking Delay (minutes)</span>
            <Tooltip label="Sets minimum buffer time between now and when a customer can book their next appointment">
              <IconInfoCircle size="1rem" style={{ cursor: 'help' }} color="gray" />
            </Tooltip>
          </Group>
        }
        value={formData?.booking_delay_mins}
        onChange={(value) => onChange('booking_delay_mins', value)}
        error={errors?.booking_delay_mins}
        min={0}
        max={2880} // 48 hours
        step={5}
      />

      <NumberInput
        label={
          <Group gap="xs">
            <span>Customer Booking Horizon (days)</span>
            <Tooltip label="Sets how far in advance customers can book appointments">
              <IconInfoCircle size="1rem" style={{ cursor: 'help' }} color="gray" />
            </Tooltip>
          </Group>
        }
        value={formData?.customer_booking_horizon_days}
        onChange={(value) => onChange('customer_booking_horizon_days', value)}
        error={errors?.customer_booking_horizon_days}
        min={0}
        max={365}
        step={1}
      />

      <Switch
        label={
          <Group gap="xs">
            <span>Appointments Require Staff Approval</span>
            <Tooltip label="Requires staff approval for new self-service bookings before blocking the time in your calendar">
              <IconInfoCircle size="1rem" style={{ cursor: 'help' }} color="gray" />
            </Tooltip>
          </Group>
        }
        checked={formData?.appts_need_accepting}
        onChange={(event) => onChange('appts_need_accepting', event.currentTarget.checked)}
        error={errors?.appts_need_accepting}
      />

      <Switch
        label={
          <Group gap="xs">
            <span>Request Customer Appointment Confirmation</span>
            <Tooltip label="Sends confirmation requests to customers a few days before their scheduled appointment">
              <IconInfoCircle size="1rem" style={{ cursor: 'help' }} color="gray" />
            </Tooltip>
          </Group>
        }
        checked={formData?.appts_need_confirmation}
        onChange={(event) => onChange('appts_need_confirmation', event.currentTarget.checked)}
        error={errors?.appts_need_confirmation}
      />
    </Stack>
  );
}

export default AdvancedSettingsFields; 